import { api } from "../lib/api";

export const send = (payload) =>
  api.post("/contact", payload).then((r) => r.data);
